import { apiFetch } from "./apiFetch";
import { getApiErrorMessage, normalizeFetchError } from "./apiError";

const API_URL = process.env.REACT_APP_API_URL;

export async function getVendorBankAccounts(
  companyId: string,
  vendorId: string
) {
  const res = await apiFetch(
    `${API_URL}/vendors/${vendorId}/bank-accounts?companyId=${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać kont bankowych.")
    );
  }

  return res.json();
}

export async function createVendorBankAccount(
  companyId: string,
  vendorId: string,
  payload: {
    iban?: string;
    bankAccountNo: string;
    currencyCode?: string;
    default?: boolean;
  }
) {
  try {
    const res = await apiFetch(
      `${API_URL}/vendors/${vendorId}/bank-accounts?companyId=${companyId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!res.ok) {
      throw new Error(
        await getApiErrorMessage(res, "Nie udało się dodać konta bankowego.")
      );
    }

    return res.json();
  } catch (e) {
    throw normalizeFetchError(e, "Nie udało się dodać konta bankowego");
  }
}

export async function getCurrencies(companyId: string) {
  const res = await apiFetch(
    `${API_URL}/vendors/currencies?companyId=${companyId}`
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się pobrać walut.")
    );
  }

  return res.json();
}

export async function setDefaultVendorBankAccount(
  companyId: string,
  vendorId: string,
  accountId: string
) {
  const res = await apiFetch(
    `${API_URL}/vendors/${vendorId}/bank-accounts/${accountId}?companyId=${companyId}`,
    {
      method: "PATCH",
    }
  );

  if (!res.ok) {
    throw new Error(
      await getApiErrorMessage(res, "Nie udało się ustawić domyślnego konta bankowego.")
    );
  }

  return res.json();
}